export default __webpack_public_path__ + "static/media/Vanshika.dd1be29e.jpg";